import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';

const routes: Routes = [
  { path: '', component: LoaderComponent },
];

@NgModule({
  declarations: [LoaderComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports : [LoaderComponent]
})
export class LoaderModule { }